module.exports = __webpack_public_path__ + "img/hakuna_bg03.899bc38f.jpg";